export enum EnumRol {
  Root = "Root",
  TenantAdmin = "TAdmin",
  OrganizationAdmin = "OAdmin",
  AreaAdmin = "AAdmin",
  Employee = "Employee",
  Servant = "Servant",
  CrossReader = "CrossReader",
}
